"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var config_1 = require("./config");

var utils_1 = require("./utils");

var document = utils_1.getDocument();

exports.createLine = function (x1, y1, x2, y2, strokeWidth, strokeColor, scales, xray) {
  if (strokeWidth === void 0) {
    strokeWidth = '1px';
  }

  if (strokeColor === void 0) {
    strokeColor = 'black';
  }

  if (scales === void 0) {
    scales = true;
  }

  if (xray === void 0) {
    xray = false;
  }

  var shapes = [];
  var line = document.createElementNS('http://www.w3.org/2000/svg', 'line');
  line.setAttribute('x1', x1.toString());
  line.setAttribute('y1', y1.toString());
  line.setAttribute('x2', x2.toString());
  line.setAttribute('y2', y2.toString());
  line.setAttribute('stroke', strokeColor);
  line.setAttribute('stroke-width', strokeWidth.toString());

  if (scales) {
    line.setAttribute('vector-effect', 'non-scaling-stroke');
  }

  if (xray) {
    line.setAttribute('stroke-dasharray', '10 2');
  }

  shapes.push(line);
  return shapes;
};

exports.createMeasurementLine = function (x1, y1, x2, y2, vertical, outerArrows, offset) {
  if (vertical === void 0) {
    vertical = false;
  }

  if (outerArrows === void 0) {
    outerArrows = false;
  }

  if (offset === void 0) {
    offset = 'center';
  }

  var shapes = [];
  var rotate = 0; // Swap the start for x/y

  if (vertical) {
    rotate = rotate - 90;
  }

  if (outerArrows) {
    rotate = rotate + 180;
  }

  var startArrow = exports.createArrow(x1, y1, rotate);
  var endArrow = exports.createArrow(x2, y2, rotate + 180);
  shapes.push(startArrow, endArrow);
  var distance = config_1.config.offsetDistance;

  if (vertical) {
    if (offset === 'left') {
      y1 = y1 + distance;
    }

    if (offset === 'right') {
      y2 = y2 - distance;
    }
  } else {
    if (offset === 'left') {
      x1 = x1 - distance;
    }

    if (offset === 'right') {
      x2 = x2 + distance;
    }
  }

  var line = exports.createLine(x1, y1, x2, y2, '1px', 'black');
  shapes.push(line);
  return shapes;
};

exports.createArrow = function (x, y, rotation, thin) {
  if (thin === void 0) {
    thin = false;
  }

  var arrowSize = config_1.config.shapes.arrowSize;
  var arrow = document.createElementNS('http://www.w3.org/2000/svg', 'polygon');
  var thickness = arrowSize / 3.5;
  arrow.setAttribute('points', x + " " + y + ", " + (x + arrowSize) + " " + (y - thickness) + ", " + (x + arrowSize) + " " + (y + thickness));
  arrow.setAttribute('transform', "rotate(" + rotation + " " + x + " " + y + ")");
  arrow.setAttribute('fill', 'black');
  return arrow;
};

exports.createExplodedText = function (x1, y1, x2, y2, content, side, showArrow) {
  if (side === void 0) {
    side = 'right';
  }

  if (showArrow === void 0) {
    showArrow = true;
  }

  var shapes = [];

  if (showArrow) {
    var mainline = exports.createLine(x1, y1, x2, y2);
    shapes.push(mainline);
    var dashline = exports.createLine(x2, y2, side === 'right' ? x2 + config_1.config.explodedTextSpace : x2 - config_1.config.explodedTextSpace, y2);
    shapes.push(dashline);
  }

  var text = exports.createText(side === 'right' ? x2 + config_1.config.explodedTextSpace + 2 : x2 - config_1.config.explodedTextSpace - 2, y2 + 12, content, false, side === 'right' ? 'start' : 'end', 'center', '15');
  shapes.push(text);

  if (showArrow) {
    var angle = Math.atan2(y2 - y1, x2 - x1) * 180 / Math.PI;
    var rotation = angle;
    var arrow = exports.createArrow(x1, y1, rotation, true);
    shapes.push(arrow);
  }

  return shapes;
};

exports.createImage = function (x, y, width, height, url, auto) {
  var image = document.createElementNS('http://www.w3.org/2000/svg', 'image');
  image.setAttribute('x', x);
  image.setAttribute('y', y);
  image.setAttribute('width', width);
  image.setAttribute('height', height);

  if (auto) {
    image.setAttribute('class', 'auto');
    image.setAttribute('preserveAspectRatio', 'none');
  }

  image.setAttributeNS('http://www.w3.org/1999/xlink', 'href', url);
  return image;
};

exports.createEllipse = function (x, y, width, height, strokeColor, strokeWidth) {
  if (strokeColor === void 0) {
    strokeColor = config_1.config.shapes.strokeColor;
  }

  if (strokeWidth === void 0) {
    strokeWidth = config_1.config.shapes.strokeWidth;
  }

  var ellipse = document.createElementNS('http://www.w3.org/2000/svg', 'ellipse');
  width = width / 2 - strokeWidth / 2;
  height = height / 2 - strokeWidth / 2;
  x = x + strokeWidth / 2 + width;
  y = y + strokeWidth / 2 + height;
  ellipse.setAttribute('cx', x.toString());
  ellipse.setAttribute('cy', y.toString());
  ellipse.setAttribute('rx', width.toString());
  ellipse.setAttribute('ry', height.toString());
  ellipse.setAttribute('fill', 'transparent');
  ellipse.setAttribute('style', "paint-order: stroke; stroke: " + strokeColor + "; stroke-width: " + strokeWidth + ";");
  return ellipse; // this.view.appendChild(ellipse);
};

exports.createRect = function (x, y, width, height, xray, fillColor, strokeColor, strokeWidth, intersectFix) {
  if (xray === void 0) {
    xray = false;
  }

  if (fillColor === void 0) {
    fillColor = 'transparent';
  }

  if (strokeColor === void 0) {
    strokeColor = config_1.config.shapes.strokeColor;
  }

  if (strokeWidth === void 0) {
    strokeWidth = config_1.config.shapes.strokeWidth;
  }

  if (intersectFix === void 0) {
    intersectFix = false;
  }

  var rect = document.createElementNS('http://www.w3.org/2000/svg', 'rect');

  if (!intersectFix) {
    width = width - strokeWidth;
    height = height - strokeWidth;
    x = x + strokeWidth / 2;
    y = y + strokeWidth / 2;
  } else {
    strokeWidth = strokeWidth * 2;
  }

  rect.setAttribute('x', x.toString());
  rect.setAttribute('y', y.toString());
  rect.setAttribute('width', width.toString());
  rect.setAttribute('height', height.toString());
  rect.setAttribute('fill', fillColor);
  rect.setAttribute('style', "paint-order: stroke; stroke: " + strokeColor + "; stroke-width: " + strokeWidth + ";");

  if (xray) {
    rect.setAttribute('stroke-dasharray', '10 2');
  }

  if (intersectFix) {
    rect.setAttribute('data-intersectfix', true);
  }

  return rect; // this.view.appendChild(rect);
};

exports.createText = function (x, y, content, vertical, alignment, offset, fontSize) {
  if (vertical === void 0) {
    vertical = false;
  }

  if (alignment === void 0) {
    alignment = 'middle';
  }

  if (offset === void 0) {
    offset = 'center';
  }

  if (fontSize === void 0) {
    fontSize = config_1.config.text.size.toString();
  }

  var text = document.createElementNS('http://www.w3.org/2000/svg', 'text');
  var style = 'paint-order: stroke; stroke: #fff;';

  if (utils_1.isNumeric(content)) {
    // Round to 2 decimal places if number
    content = Math.ceil(content);
  } // Adjust position of text


  var distance = config_1.config.shapes.arrowSize + 3;

  if (vertical) {
    if (offset === 'left') {
      y = y + distance;
    }

    if (offset === 'right') {
      y = y - distance;
    }

    x = x - 12;
    style = style + 'stroke-width: 2;';
    text.setAttribute('transform', "rotate(-90, " + x + ", " + y + ")");
  } else {
    if (offset === 'left') {
      x = x - distance;
    }

    if (offset === 'right') {
      x = x + distance;
    }

    y = y - 12;
    style = style + 'stroke-width: 3;';
  }

  text.setAttribute('x', x.toString());
  text.setAttribute('y', y.toString());
  text.setAttribute('fill', '#000');
  text.setAttribute('font-size', fontSize);
  text.setAttribute('style', style);
  text.setAttribute('font-family', '-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol');
  text.setAttribute('alignment-baseline', 'middle');
  text.setAttribute('text-anchor', alignment);

  if (Array.isArray(content)) {
    var innerHtml = '';

    for (var i = 0; i < content.length; i++) {
      innerHtml = innerHtml + ("<tspan x=\"" + x + "\" dy=\"" + (i === 0 ? '0' : '1.2em') + "\">" + content[i] + "</tspan>");
    }

    text.innerHTML = innerHtml;
  } else {
    text.innerHTML = content.toString();
  }

  return text;
};

exports.createArc = function (x, y, radius, startAngle, endAngle, strokeWidth, strokeColor, xray) {
  if (strokeWidth === void 0) {
    strokeWidth = '1px';
  }

  if (strokeColor === void 0) {
    strokeColor = 'black';
  }

  if (xray === void 0) {
    xray = false;
  }

  var polarToCartesian = function polarToCartesian(centerX, centerY, r, angleInDegrees) {
    var angleInRadians = (angleInDegrees - 90) * Math.PI / 180.0;
    return {
      x: centerX + r * Math.cos(angleInRadians),
      y: centerY + r * Math.sin(angleInRadians)
    };
  };

  var start = polarToCartesian(x, y, radius, endAngle);
  var end = polarToCartesian(x, y, radius, startAngle);
  var largeArcFlag = endAngle - startAngle <= 180 ? '0' : '1';
  var d = ['M', start.x, start.y, 'A', radius, radius, 0, largeArcFlag, 0, end.x, end.y].join(' ');
  var arc = document.createElementNS('http://www.w3.org/2000/svg', 'path');
  arc.setAttribute('d', d);
  arc.setAttribute('alignment-baseline', 'middle');
  arc.setAttribute('fill', 'transparent');
  arc.setAttribute('style', "paint-order: stroke; stroke: " + strokeColor + "; stroke-width: " + strokeWidth + ";");

  if (xray) {
    arc.setAttribute('stroke-dasharray', '10 2');
  }

  return arc; // this.view.appendChild(arc);
};

exports.createCrosshair = function (x, y, width, height, hasInner, hasOuter) {
  if (hasInner === void 0) {
    hasInner = true;
  }

  if (hasOuter === void 0) {
    hasOuter = true;
  }

  var shapes = [];

  if (hasInner) {
    var innerCircle = exports.createEllipse(x, y, width, height, 'black', 1);
    shapes.push(innerCircle);
  }

  if (hasOuter) {
    var outerCircle = exports.createEllipse(x - width * 0.15, y - height * 0.15, width * 1.3, height * 1.3, 'black', 1);
    shapes.push(outerCircle);
  }

  var lineScale = 2;
  var xCenter = x + width / 2;
  var yCenter = y + height / 2;
  var xLine = exports.createLine(xCenter - width / 2 * lineScale, yCenter, xCenter + width / 2 * lineScale, yCenter);
  shapes.push(xLine);
  var yLine = exports.createLine(xCenter, yCenter - height / 2 * lineScale, xCenter, yCenter + height / 2 * lineScale);
  shapes.push(yLine);
  return shapes;
};

exports.createVerticalWall = function (x1, y1, x2, y2, side, showBorder, thickness, gutter, strokeThickness) {
  if (showBorder === void 0) {
    showBorder = true;
  }

  if (!thickness) {
    thickness = config_1.config.wall.thickness;
  }

  if (!gutter) {
    gutter = config_1.config.wall.gutter;
  }

  if (!strokeThickness) {
    strokeThickness = config_1.config.wall.strokeThickness;
  }

  var slant = thickness;
  var shapes = [];
  var lineCount = (y1 - y2) / gutter;
  var xOffset = side === 'left' ? -thickness : thickness;
  var yOffset = side === 'left' ? slant : -slant; // Lines from top to bottom

  for (var i = -1; i < lineCount + 1; i++) {
    var line = exports.createLine(x1 + xOffset, y2 + i * gutter + yOffset, x1, y2 + i * gutter, strokeThickness);
    shapes.push(line);
  } // Lines cover (since they go out of bounds)


  var coverXOffset = side === 'left' ? -thickness : 0;
  var topCover = exports.createRect(x1 + coverXOffset, y2 - gutter * 2, thickness, gutter * 2, false, 'white', 'white');
  shapes.push(topCover);
  var bottomCover = exports.createRect(x1 + coverXOffset, y1, thickness, gutter * 2, false, 'white', 'white');
  shapes.push(bottomCover); // Left/right needs a border line

  if (showBorder) {
    var border = exports.createLine(x1, y1, x1, y2);
    shapes.push(border);
  }

  return shapes;
};

exports.createHorizontalWall = function (x1, y1, x2, y2, side, hasLeftWall, hasRightWall, overhang, thickness, gutter, strokeThickness) {
  if (hasLeftWall === void 0) {
    hasLeftWall = false;
  }

  if (hasRightWall === void 0) {
    hasRightWall = false;
  }

  if (overhang === void 0) {
    overhang = true;
  }

  if (!thickness) {
    thickness = config_1.config.wall.thickness;
  }

  if (!gutter) {
    gutter = config_1.config.wall.gutter;
  }

  if (!strokeThickness) {
    strokeThickness = config_1.config.wall.strokeThickness;
  }

  var slant = thickness;
  var shapes = [];

  if (overhang) {
    x1 = x1 - thickness;
    x2 = x2 + thickness;
  }

  var lineCount = (x2 - x1) / gutter; // Lines from right to left

  for (var i = -1; i < lineCount + 2; i++) {
    var line = exports.createLine(x2 - i * gutter, y1, x2 - i * gutter + slant, y1 - thickness, strokeThickness);
    shapes.push(line);
  } // Lines cover (since they go out of bounds)


  var leftCover = exports.createRect(x1 - thickness * 2, y1 - thickness, thickness * 2, thickness, false, 'white', 'white');
  shapes.push(leftCover);
  var rightCover = exports.createRect(x2, y1 - thickness, thickness * 2, thickness, false, 'white', 'white');
  shapes.push(rightCover); // Border line

  var borderX1 = hasLeftWall ? x1 + thickness : x1;
  var borderX2 = hasRightWall ? x2 - thickness : x2;
  var border = exports.createLine(borderX1, y1, borderX2, y1);
  shapes.push(border);
  return shapes;
};

exports.createFloor = function () {// TODO
};